import { render, staticRenderFns } from "./CenterCard.vue?vue&type=template&id=53e6aa4e&scoped=true&"
import script from "./CenterCard.vue?vue&type=script&lang=js&"
export * from "./CenterCard.vue?vue&type=script&lang=js&"
import style0 from "./CenterCard.vue?vue&type=style&index=0&id=53e6aa4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6aa4e",
  null
  
)

export default component.exports